"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArticleContent = void 0;

var _react = _interopRequireDefault(require("react"));

var _knotchincWebReactComponents = _interopRequireDefault(require("@bit/knotchinc.web-react-components.box"));

var _knotchincWebReactComponents2 = _interopRequireDefault(require("@bit/knotchinc.web-react-components.text"));

var _knotchincWebReactComponents3 = _interopRequireDefault(require("@bit/knotchinc.web-react-components.error"));

var _knotchincWebReactComponents4 = _interopRequireDefault(require("@bit/knotchinc.web-react-components.content-count-block"));

var _styled = require("./styled.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ArticleContent = function ArticleContent(props) {
  var metadata = props.data,
      metrics = props.metrics,
      headerComponent = props.headerComponent,
      showHighlightedKeywords = props.showHighlightedKeywords;
  var content = metadata.content,
      title = metadata.title,
      page_url = metadata.page_url,
      keyword_tags = metadata.keyword_tags;
  var formattedContentWithoutHighlightedKeywords = '';
  var formattedContentWithHighlightedKeywords = '';

  function getFormattedContent(originalContent) {
    return originalContent.split('\n').map(function (block) {
      return "<p>".concat(block, "</p>");
    }).join('');
  }

  if (content && content.length) {
    var contentForKeywords = content;

    for (var i = 0; i < keyword_tags.length; i++) {
      //Do a case insensitive replace all
      var reg = new RegExp('\\b' + keyword_tags[i].value + '\\b', 'gi');
      contentForKeywords = contentForKeywords.replace(reg, function (str) {
        return "<b style=\"color:#2D8BFF;\">".concat(str, "</b>");
      });
    }

    formattedContentWithHighlightedKeywords = getFormattedContent(contentForKeywords);
    formattedContentWithoutHighlightedKeywords = getFormattedContent(content);
  }

  return /*#__PURE__*/_react["default"].createElement(_styled.ScrollContainer, null, /*#__PURE__*/_react["default"].createElement(_styled.QuestionPageContainer, null, /*#__PURE__*/_react["default"].createElement(_styled.StyledWidthContainer, null, headerComponent, /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents["default"], {
    width: "60%",
    display: "inline-block",
    verticalAlign: "top"
  }, /*#__PURE__*/_react["default"].createElement(_styled.ScrollNavBar, null, /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents4["default"], {
    fontSize: "12px",
    counts: metrics
  }))))), /*#__PURE__*/_react["default"].createElement(_styled.StyledArticleContent, null, /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents["default"], null, /*#__PURE__*/_react["default"].createElement(_styled.Label, {
    light: true
  }, "Content Title"), /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents2["default"], {
    fontWeight: "thin",
    fontSize: "18px",
    letterSpacing: "0.02em",
    color: "white",
    mb: "48px"
  }, title)), /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents["default"], {
    display: "inline-block",
    width: "80%",
    verticalAlign: "top"
  }, content ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "content",
    dangerouslySetInnerHTML: {
      __html: showHighlightedKeywords ? formattedContentWithHighlightedKeywords : formattedContentWithoutHighlightedKeywords
    }
  }) : /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents3["default"], {
    noArticleContent: true,
    padding: "0"
  })), /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents4["default"], {
    counts: metrics
  }, /*#__PURE__*/_react["default"].createElement(_styled.PillButton, {
    onClick: function onClick() {
      return window.open(page_url);
    }
  }, "view"))));
};

exports.ArticleContent = ArticleContent;

//# sourceMappingURL=ArticleContent.js.map